import { createDedupedRequest } from '../utils/request-dedupe';

/**
 * Chỗ DUY NHẤT giữ trạng thái chống-gọi-trùng của `GET /user/get-me`.
 *
 * Cố tình KHÔNG import axiosClient ở đây: axiosClient phải gọi được `reset()`
 * (mỗi lần web ghi dữ liệu lên server) mà không tạo vòng lặp import.
 *
 * TTL 3s: đủ gộp cụm gọi lúc mở trang / đổi route, nhưng ngắn hơn nhịp user kịp
 * nhận ra số liệu cũ. Mọi request khác GET đều reset cache (xem axiosClient) nên
 * số dư không bao giờ hiện cũ sau khi rút tiền / đổi voucher.
 */
const getMeCache = createDedupedRequest({ ttlMs: 3000 });

export default getMeCache;
